const SECOND_LIST = [ // 页面操作延时TOP对照
    {
        label: '60s及以上',
        value: ['fiveMinute', 'tenMinute']
    },
    {
        label: '30-60s',
        value: ['halfOneMinute', 'oneMinute']
    },
    {
        label: '9-10s',
        value: ['nineSecond']
    },
    {
        label: '7-8s',
        value: ['sevenSecond', 'eightSecond']
    },
    {
        label: '5-6s',
        value: ['fiveSecond', 'sixSecond']
    },
    {
        label: '3-4s',
        value: ['threeSecond', 'fourSecond']
    },
    {
        label: '1-2s',
        value: ['oneSecond', 'twoSecond']
    }
];
const formatData = function(data) {
    const secondList = [];
    const dataList = [];
    SECOND_LIST.forEach(item => {
        secondList.push(item.label);
        const itemCountList = item.value.map(item => {
            const itemData = data[item];
            return itemData ? itemData.allCount : '';
        });
        const itemCount = itemCountList.reduce(function (pre, next) {
            return pre + next;
        });
        dataList.push(itemCount || '');
    });
    return { secondList, dataList };
};
const formatDetailData = function(data) {
    const secondList = [];
    const dataList = [];
    data.forEach(item => {
        secondList.push(item.apiName);
        dataList.push(item.count);
    });
    return { secondList, dataList };
};
const formatType = function(data, type) {
    if (type) {
        return formatDetailData(data);
    } else {
        return formatData(data);
    }
};
export const getTimeDelayOption = function (data = {}, type) {
    const { secondList, dataList } = formatType(data, type);
    return {
        color: ['#4285F5 '],
        grid: {
            top: '0',
            right: '20%',
            bottom: '5%',
            left: '4%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            show: false,
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'category',
            data: secondList,
            axisLabel: {
                show: true,
                margin: 12,
                textStyle: {
                    color: '#333333',
                    fontSize: 12,
                    fontFamily: 'PingFangSC-Regular',
                    fontWeight: 400
                }
            },
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    width: 1,
                    color: '#eaeaea'
                }
            },
            axisTick: {
                show: false
            }
        },
        series: [
            {
                data: dataList,
                type: 'bar',
                barWidth: 12,
                barMinHeight: 2,
                label: {
                    show: true,
                    position: 'right',
                    padding: [0, 0, 0, 10],
                    formatter: params => {
                        const { value } = params;
                        return value ? value.toLocaleString() : value;
                    },
                    textStyle: {
                        fontSize: 14,
                        fontFamily: 'PingFangSC-Medium',
                        fontWeight: 600
                    }
                },
                itemStyle: {
                    barBorderRadius: [0, 2, 2, 0]
                }
            }
        ]
    };
};